<template>
  <div>
    <card>
        <div class="row">
            <div class="col" style="margin-bottom:10px">
                <router-link :to="'crea-soggetto?idCliente='+idCliente"><button class="btn float-left" type="button" style="background:#00467f">CREA SOGGETTO</button></router-link>
            </div>
        </div>
        <table class="table tablesorter" id="tabella" style="text-align: center">
            <thead>
                <tr>
                    <th></th>
                    <th>Nominativo</th>
                    <th>Codice Fiscale</th>
                    <th>Tipo</th>
                    <th>Principale</th>
                    <th>Non in carica</th>
                    <th>Titolare Effettivo</th>
                    <th>PEP</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-color" v-for="valori in allSoggetti" v-bind:key="valori.ID"><!--  -->
                    <td @click="caricaSoggetto(valori.ID)">
                        <i class="tim-icons icon-pencil" style="color:#00467f"></i>
                    </td>
                    <td>{{valori.COGNOME}} {{valori.NOME}}</td>
                    <td>{{valori.CF}}</td>
                    <td>{{valori.TIPO}}</td>
                    <!-- <td>{{valori.RAPPRESENTANTE_PRINCIPALE}}</td> -->
                    <td>
                        <span v-if="valori.RAPPRESENTANTE_PRINCIPALE == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                        <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                    </td>
                    <td>
                        <!-- {{valori.NON_IN_CARICA}} -->
                        <span v-if="valori.NON_IN_CARICA == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                        <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                    </td>
                    <td>
                        <!-- {{valori.TITOLARE_EFFETTIVO}} -->
                        <span v-if="valori.TITOLARE_EFFETTIVO == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                        <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                    </td>
                    <td>
                        <!-- {{valori.PEP}} -->
                        <span v-if="valori.PEP == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                        <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                    </td>
                    <!-- <td><button v-on:click="caricaSoggetto(valori.ID)"><i class="tim-icons icon-pencil" style="color:#00467f"></i></button></td> -->
                </tr>
            </tbody>
        </table>
        <router-link v-if="idSoggetto == null" :to="'/valutazione-a?idCliente='+idCliente" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link>
    </card>
    <hr>
    <card v-if="idSoggetto != null">
        <h3 style="color:#00467f">Dati Soggetto</h3>
        <!-- <hr> -->
        <form>
            <div class="form-row">
                <!-- <div class="form-group col-md-1"> -->
                    <label style="color:#00467f;display: flex;word-wrap: break-word;vertical-align: middle;" for="soggetto_estero"><input type="checkbox" v-model="soggetto_estero" id="soggetto_estero" style="margin-left:5px;" class="form-control">Soggetto Estero (impostare questo flag solo per la gestione di soggetti senza codice fiscale italiano)</label>
                <!-- </div> -->
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="codice_fiscale">Codice Fiscale<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="codice_fiscale" placeholder="codice_fiscale">
                </div>
                <div class="form-group col-md-4">
                    <label for="cognome">Cognome<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="cognome" placeholder="cognome">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome">Nome<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="nome" placeholder="Nome">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="data_nascita">Data di nascita<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_nascita" placeholder="data_nascita">
                </div>
                <div class="form-group col-md-4">
                    <label for="comune_nascita">Comune di nascita<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="comune_nascita" placeholder="comune_nascita">
                </div>
                <div class="form-group col-md-4">
                    <label for="provincia">Provincia di nascita<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="provincia" placeholder="provincia"> -->
                    <select v-model="provincia" class="form-control">
                        <option disabled value="">Seleziona una provincia</option>
                        <option v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value">{{val.text}}</option>
                    </select>
                </div>
            </div>
            <!-- -->
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="sesso">Sesso<span style="color:#ff0000">*</span></label>
                    <select v-model="sesso" class="form-control">
                        <option>M</option>
                        <option>F</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="stato">Stato<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="stato" placeholder="stato">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo">Tipo<span style="color:#ff0000">*</span></label>
                    <select v-model="tipo" class="form-control">
                        <option value="titolare ditta individuale">Titolare ditta individuale</option>
                        <option value="rappresentante legale">Rappresenante legale</option>
                        <option value="amministratore delegato">Amministratore delegato</option>
                        <option value="delegato a operare">Delegato a operare</option>
                        <option value="socio">Socio</option>
                        <option value="esecutore">Esecutore</option>
                    </select>
                </div>
            </div>
            <h3 style="margin-top:20px;color:#00467f">Residenza</h3>
            <!-- <hr> -->
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="indirizzo_residenza">Indirizzo<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="indirizzo_residenza" placeholder="indirizzo_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="comune_residenza">Comune<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="comune_residenza" placeholder="comune_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="cap_residenza">CAP<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="cap_residenza" placeholder="cap_residenza">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="provincia_residenza">Provincia<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="provincia_residenza" placeholder="provincia_residenza"> -->
                    <select v-model="provincia_residenza" class="form-control">
                        <option disabled value="">Seleziona una provincia</option>
                        <option v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value">{{val.text}}</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="stato_residenza">Stato<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="stato_residenza" placeholder="stato_residenza">
                </div>
            </div>
            <h3 style="margin-top:10px">Dati Antiriciclaggio</h3>
            <div class="form-row">
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="titolare_effettivo" class="form-control">Titolare Effettivo</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="pep"  class="form-control">PEP (Persona Politicamente Esposta)</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="rappresentante_principale" class="form-control">Rappresentante Principale</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="non_in_carica" class="form-control">Non in carica</label>
                </div>
            </div>
            <div class="form-row justify-content-center" style="margin-top:10px">
                <div class="col-md">
                     <label>Titolare effettivo dal</label>
                     <input type="date" class="form-control" v-model="titolare_effettivo_dal">
                </div>
                <div class="col-md">
                     <label>Titolare effettivo al</label>
                     <input type="date" class="form-control" v-model="titolare_effettivo_al">
                </div>
            </div>
            <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f; margin-bottom:15px">Salva</button>
        
            <h3 style="margin-top:20px;color:#00467f">Identificazione<span style="color:#ff0000">*</span></h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="tipo_identificazione">Tipo identificazione</label>
                    <select v-model="tipo_identificazione" class="form-control">
                        <option value="Direttamente">Direttamente</option>
                        <option value="tramite atti">Tramite atti</option>
                        <option value="dic consolare">Dic. consolare</option>
                        <option value="altro profess">Altro profess.</option>
                        <option value="interm. abilitati">Interm. Abilitati</option>
                        <option value="altre modalità">Altre modalità</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="data">Data<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo_documento">Tipo Documento<span style="color:#ff0000">*</span></label>
                    <select v-model="tipo_documento" class="form-control">
                        <option value="carta identita">Carta d'identità</option>
                        <option value="patente">Patente</option>
                        <option value="passaporto">Passaporto</option>
                        <option value="porto d'armi">Porto d'armi</option>
                        <option value="tess. postale">Tess. postale</option>
                        <option value="altro">Altro</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="numero_documento">Numero Documento<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="numero_documento" placeholder="numero_documento">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_scadenza">Data Scadenza<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_scadenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_rilascio">Data Rilascio<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_rilascio">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="autorita_localita_rilascio">Autorità e località del rilascio<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="autorita_localita_rilascio">
                </div>
                <div class="form-group col-md-6">
                    <label for="tipo_documento">Dati acquisiti e verificati tramite<span style="color:#ff0000">*</span></label>
                    <select v-model="dati_acquisiti" class="form-control">
                        <option value="dichiarazione antiriciclaggio">Dichiarazione antiriciclaggio resa dal cliente x art. 22 D.Lgs 231/2007</option>
                        <option value="estratti pubblici registri">Estratti pubblici registri</option>
                        <option value="estratti elenchi">Estratti da elenchi, atti, documenti conoscibili da chiunque</option>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica documento personale<span style="color:#ff0000">*</span></h3>
                    <button class="btn" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()" accept=".jpg,.jpeg,.png,.pdf"></button>
                </div>
            </div>
            <div class="form-row" v-if="soggetto.ANTIRIC_SOGGETTO_META != null && soggetto.ANTIRIC_SOGGETTO_META.length > 0">
                <!-- <ul>
                    <li v-for="(value, index) in soggetto.ANTIRIC_SOGGETTO_META" v-bind:key="index">{{value.VALUE.name}}</li>
                </ul> -->
                <div class="col-8">
                    <p>File caricati:</p>
                    <div v-for="(value, index) in soggetto.ANTIRIC_SOGGETTO_META" v-bind:key="index">
                        <p><a :href="url+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                    </div>
                </div>
                <div class="col">
                    <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva dati identificazione</button>
                </div>
            </div>
            <!-- <div class="mb-3"> -->
            <!-- </div> -->
            <h1></h1>
        </form>
        <!-- <hr> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <div style="margin-top:15px">
            <router-link :to="'/prestazioni?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
            <router-link :to="'/valutazione-a?idCliente='+idCliente" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link>
        </div>
        <!--  MODAL CARICARE FILE -->
        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                    <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
        Card
    },

    data() {
        return {
            url: 'https://sviluppoallergeni.confcom.it',
            // DATI SOGGETTI
            codice_fiscale: null,
            soggetto_estero: false,
            cognome: null,
            nome: null,
            data_nascita: null,
            comune_nascita: null,
            provincia: null,
            listaProvince: [
               { value: "AG", text: "AG	Agrigento"}, { value: "AL", text: "AL Alessandria"}, 
               { value: "AN", text: "AN	Ancona"}, { value: "AO", text: "AO	Aosta"}, {value: "AQ", text: "AQ L'Aquila"}, 
               { value: "AR", text: "AR Arezzo"}, { value: "AP", text: "AP	Ascoli-Piceno"}, {value: "AT", text: "AT Asti"}, 
               { value: "BA", text: "BA	Bari"}, { value: "BT", text: "BT Barletta-Andria-Trani"}, {value: "BL", text: "BL Belluno"}, 
               { value: "BN", text: "BN Benevento"}, { value: "BG", text: "BG Bergamo"}, {value: "BI", text: "BI Biella"}, 
               { value: "BO", text: "BO	Bologna"}, { value: "BZ", text: "BZ Bolzano"}, {value: "BS", text: "BS Brescia"}, 
               { value: "BR", text: "BR Brindisi"}, { value: "CA", text: "CA Cagliari"}, {value: "CL", text: "CL Caltanissetta"}, 
               { value: "CB", text: "CB	Campobasso"}, { value: "CI", text: "CI Carbonia Iglesias"}, {value: "CE", text: "CE Caserta"}, 
               { value: "CT", text: "CT	Catania"}, { value: "CZ", text: "CZ Catanzaro"}, {value: "CH", text: "CH Chieti"}, 
               { value: "CO", text: "CO Como"}, { value: "CS", text: "CS Cosenza"}, {value: "CR", text: "CR	Cremona"}, 
               { value: "KR", text: "KR Crotone"}, { value: "CN", text: "CN	Cuneo"}, {value: "EN", text: "EN Enna"}, 
               { value: "FM", text: "FM	Fermo"}, { value: "FE", text: "FE Ferrara"}, {value: "FI", text: "FI Firenze"},
                { value: "FG", text: "FG Foggia"}, { value: "FC", text: "FC Forli-Cesena"}, {value: "FR", text: "FR Frosinone"}, 
               { value: "GE", text: "GE	Genova"}, { value: "GO", text: "GO Gorizia"}, {value: "GR", text: "GR Grosseto"}, 
               { value: "IM", text: "IM	Imperia"}, { value: "IS", text: "IS Isernia"}, {value: "SP", text: "SP La-Spezia"},
               { value: "LT", text: "LT	Latina"}, { value: "LE", text: "LE Lecce"}, {value: "LC", text: "LC Lecco"}, 
               { value: "LI", text: "LI	Livorno"}, { value: "LO", text: "LO	Lodi"}, {value: "LU", text: "LU	Lucca"}, 
               { value: "MC", text: "MC	Macerata"}, { value: "MN", text: "MN Mantova"}, {value: "MS", text: "MS	Massa-Carrara"}, 
               { value: "MT", text: "MT	Matera"}, { value: "VS", text: " VS Medio Campidano"}, {value: "ME", text: "ME Messina"}, 
               { value: "MI", text: "MI	Milano"}, { value: "MO", text: "MO Modena"}, {value: "MB", text: "MB Monza-Brianza"}, 
               { value: "NA", text: "NA	Napoli"}, { value: "NO", text: " NO	Novara"}, {value: "NU", text: "NU Nuoro"}, 
               { value: "OG", text: "OG	Ogliastra"}, { value: "OT", text: "OT Olbia Tempio"}, {value: "OR", text: "OR Oristano"}, 
               { value: "PD", text: "PD	Padova"}, { value: "PA", text: "PA Palermo"}, {value: "PR", text: "PR Parma"}, 
               { value: "PV", text: "PV	Pavia"}, { value: "PG", text: "PG Perugia"}, {value: "PU", text: "PU Pesaro-Urbino"}, 
               { value: "PE", text: "PE Pescara"}, { value: "PC", text: "PC Piacenza "}, {value: "PI", text: "PI Pisa"}, 
               { value: "PT", text: "PT	Pistoia"}, { value: "PN", text: "PN	Pordenone"}, {value: "PZ", text: "PZ Potenza"}, 
               { value: "PO", text: "PO	Prato"}, { value: "RG", text: "RG Ragusa"}, {value: "RA", text: "RA	Ravenna"}, 
               { value: "RC", text: "RC	Reggio-Calabria"}, { value: "RE", text: "RE	Reggio-Emilia"}, {value: "RI", text: "RI Rieti"}, 
               { value: "RN", text: "RN	Rimini"}, { value: "Roma", text: "Roma Roma"}, {value: "RO", text: "RO	Rovigo"}, 
               { value: "SA", text: "SA	Salerno"}, { value: "SS", text: "SS	Sassari"}, {value: "SV", text: "SV Savona"}, 
               { value: "SI", text: "SI	Siena"}, { value: "SR", text: "SR Siracusa"}, {value: "SO", text: "SO Sondrio"}, 
               { value: "TA", text: "TA	Taranto"}, { value: "TE", text: "TE	Teramo"}, {value: "TR", text: "TR Terni"}, 
               { value: "TO", text: "TO	Torino"}, { value: "TP", text: "TP Trapani"}, {value: "TN", text: "TN Trento"}, 
               { value: "TV", text: "TV	Treviso "}, { value: "TS", text: "TS Trieste"}, {value: "UD", text: "UD	Udine"}, 
               { value: "VA", text: "VA	Varese"}, { value: "VE", text: "VE Venezia"}, {value: "VB", text: "VB	Verbania"}, 
               { value: "VC", text: "VC	Vercelli"}, { value: "VR", text: "VR Verona"}, {value: "VV", text: "VV Vibo-Valentia"}, 
               { value: "VI", text: "VI	Vicenza"}, { value: "VT", text: " VT	Viterbo"}
            ],
            sesso: null,
            stato: null,
            tipo: null,
            titolare_effettivo: false, 
            pep:false, 
            rappresentante_principale: false, 
            non_in_carica: false, 

            titolare_effettivo_da: null,
            titolare_effettivo_al: null,
            
            // RESIDENZA
            indirizzo_residenza: null,
            comune_residenza: null,
            cap_residenza: null,
            provincia_residenza: null,
            stato_residenza: null,
            
            // IDENTIFICAZIONE
            tipo_identificazione: null,
            numero_documento: null,
            autorita_localita_rilascio: null,
            data: null,
            data_scadenza: null,
            tipo_documento: null,
            data_rilascio: null,
            dati_acquisiti: null,

            showCheckFile: false,
            showLoader: false,

            idCliente: null,
            idSoggetto: null,

            allSoggetti: [],
            soggetto: [],
        }
    },
    computed: {},

    methods: {
        caricaSoggetto: async function(idSoggetto) {
            let errore = 0;
            this.idSoggetto = idSoggetto;
            await AntiriciclaggioServices.getSoggetto(this.idCliente, idSoggetto)
            .then(response => { this.soggetto= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaSoggetto(this.idCliente, idSoggetto); }
            }
            console.log(`soggetto`);
            console.log(this.soggetto);
            this.codice_fiscale = this.soggetto.CF;
            this.soggetto_estero = this.soggetto.SOGGETTO_ESTERO;
            this.cognome = this.soggetto.COGNOME
            this.nome = this.soggetto.NOME;
            this.data_nascita = this.soggetto.DATA_NASCITA;
            this.comune_nascita = this.soggetto.COMUNE_NASCITA
            this.provincia = this.soggetto.PROVINCIA_NASCITA
            this.sesso = this.soggetto.SESSO;
            this.stato = this.soggetto.STATO_NASCITA
            this.tipo = this.soggetto.TIPO;
            this.titolare_effettivo = this.soggetto.TITOLARE_EFFETTIVO;
            this.pep = this.soggetto.PEP; 
            this.rappresentante_principale = this.soggetto.RAPPRESENTANTE_PRINCIPALE; 
            this.non_in_carica = this.soggetto.NON_IN_CARICA;
            
            // RESIDENZA
            this.indirizzo_residenza = this.soggetto.INDIRIZZO_RESIDENZA;
            this.comune_residenza = this.soggetto.COMUNE_RESIDENZA;
            this.cap_residenza = this.soggetto.CAP_RESIDENZA;
            this.provincia_residenza = this.soggetto.PROVINCIA_RESIDENZA;
            this.stato_residenza = this.soggetto.STATO_RESIDENZA;
            
            // IDENTIFICAZIONE
            this.tipo_identificazione = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_TIPO;
            this.numero_documento = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_NUMERO_DOCUMENTO
            this.autorita_localita_rilascio = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_AUTORITA;
            this.data = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_DATA;
            this.data_scadenza = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_DATA_SCADENZA;
            this.tipo_documento = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_TIPO_DOCUMENTO;
            this.data_rilascio = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.IDENTIFICAZIONE_DATA_RILASCIO;
            this.dati_acquisiti = this.soggetto.ANTIRIC_SOGGETTO_META[length].VALUE.MODALITA_ACQUISIZIONE_DATI;
            console.log(`IDENTIFICAZIONE_TIPO = ${this.tipo_identificazione}, IDENTIFICAZIONE_NUMERO_DOCUMENTO = ${this.numero_documento}, IDENTIFICAZIONE_AUTORITA = ${this.autorita_localita_rilascio}`);
            if ( this.soggetto.ANTIRIC_SOGGETTO_META != null && this.soggetto.ANTIRIC_SOGGETTO_META.length > 0) {
                for (let i=0; i < this.soggetto.ANTIRIC_SOGGETTO_META.length; ++i) {
                    // console.log(this.soggetto.ANTIRIC_SOGGETTO_META[i].VALUE);
                    console.log(this.soggetto.ANTIRIC_SOGGETTO_META[i].VALUE.name);
                }
            }
        },

        checkData: function() {
            if (this.codice_fiscale == null || this.cognome == null || this.nome == null || this.data_nascita == null 
                || this.comune_nascita == null || this.provincia == null || this.sesso == null || this.stato == null || this.tipo == null 
                // || this.titolare_effettivo == null || this.pep == null || this.rappresentante_principale == null || this.non_in_carica == null 
                || this.indirizzo_residenza== null || this.comune_residenza == null || this.cap_residenza == null || this.provincia_residenza == null 
                || this.stato_residenza == null 
                /*|| this.tipo_identificazione == null || this.numero_documento == null || this.autorita_localita_rilascio == null 
                || this.data == null || this.data_scadenza == null || this.tipo_documento == null || this.data_rilascio == null || this.dati_acquisiti == null*/
                ) {
                    return false;
                } else {
                    return true;
                }
        },

        checkDatiIdentificazione: function() {
            if (this.tipo_identificazione == null || this.numero_documento == null || this.autorita_localita_rilascio == null 
                || this.data == null || this.data_scadenza == null || this.tipo_documento == null || this.data_rilascio == null || this.dati_acquisiti == null) {
                    return false;
                } else {
                    return true;
                }
        },

        checkFileUpload: function() {
            this.showCheckFile = true;
        },

        getAllSoggetti: async function() {
            let errore = 0;
            await AntiriciclaggioServices.getAllSoggetti(this.idCliente)
            .then(response => { this.allSoggetti= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getAllSoggetti(this.idCliente); }
            }
            console.log(`allSoggetti`);
            console.log(this.allSoggetti);
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            // let token = localStorage.getItem('access_token');
            // let risposta;
            // let errore = 0;
            // this.file = this.$refs.file.files[0];
            // let formData = new FormData()
            // formData.append('documento', this.file)
            //  let identificazione = { IDENTIFICAZIONE: {
            //     IDENTIFICAZIONE_TIPO: this.tipo_identificazione, IDENTIFICAZIONE_NUMERO_DOCUMENTO: this.numero_documento, 
            //     IDENTIFICAZIONE_AUTORITA: this.autorita_localita_rilascio, 
            //     IDENTIFICAZIONE_DATA: this.data, IDENTIFICAZIONE_DATA_SCADENZA: this.data_scadenza, IDENTIFICAZIONE_TIPO_DOCUMENTO: this.tipo_documento, 
            //     IDENTIFICAZIONE_DATA_RILASCIO: this.data_rilascio, MODALITA_ACQUISIZIONE_DATI: this.dati_acquisiti}
            // };
            // console.log(identificazione);
            
            // formData.append('IDENTIFICAZIONE', JSON.stringify(identificazione));
            // await AntiriciclaggioServices.caricaDocumentoSoggetto(this.idCliente, this.idSoggetto, formData)
            // .then(response => { risposta = response.data})
            // .catch( function (error) {
            //     // handle error
            //     if(error.response.status == 401){
            //         errore = error.response.status;
            //     }
            // })
            // if (errore == 401) {
            //     console.log(`errore 401`);
            //     let value = await Services.refreshTokenFunction();
            //     if (value) { await this.handleFileUpload(); }
            // }
            this.showCheckFile = false;
            this.showLoader = false;
            // await this.getFileCaricati();
        },
        salvaValoriIdentificazione: async function() {
            // let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            let identificazione = { IDENTIFICAZIONE: {
                IDENTIFICAZIONE_TIPO: this.tipo_identificazione, IDENTIFICAZIONE_NUMERO_DOCUMENTO: this.numero_documento, 
                IDENTIFICAZIONE_AUTORITA: this.autorita_localita_rilascio, 
                IDENTIFICAZIONE_DATA: this.data, IDENTIFICAZIONE_DATA_SCADENZA: this.data_scadenza, IDENTIFICAZIONE_TIPO_DOCUMENTO: this.tipo_documento, 
                IDENTIFICAZIONE_DATA_RILASCIO: this.data_rilascio, MODALITA_ACQUISIZIONE_DATI: this.dati_acquisiti}
            };
            console.log(identificazione);
            if (this.checkDatiIdentificazione) {
                formData.append('IDENTIFICAZIONE', JSON.stringify(identificazione));
                await AntiriciclaggioServices.caricaDocumentoSoggetto(this.idCliente, this.idSoggetto, formData)
                .then(response => { risposta = response.data})
                .catch( function (error) {
                    // handle error
                    if(error.response.status == 401){
                        errore = error.response.status;
                    }
                })
                if (errore == 401) {
                    console.log(`errore 401`);
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriIdentificazione(); }
                }
            } else {
                alert("Compilare tutti i dati relativi all'identificazione del documento.");
            }
        },

        salvaValoriDati: async function() {
            if (this.checkData()) {
                let errore = 0;
                let dati = [];
                dati.push({ 
                    SOGGETTO_ESTERO: this.soggetto_estero, CF: this.codice_fiscale, COGNOME: this.cognome, NOME: this.nome, DATA_NASCITA: this.data_nascita, COMUNE_NASCITA: this.comune_nascita, 
                    PROVINCIA_NASCITA: this.provincia, SESSO: this.sesso, STATO_NASCITA: this.stato, TIPO: this.tipo, INDIRIZZO_RESIDENZA: this.indirizzo_residenza, 
                    COMUNE_RESIDENZA: this.comune_residenza, CAP_RESIDENZA: this.cap_residenza, PROVINCIA_RESIDENZA: this.provincia_residenza, STATO_RESIDENZA: this.stato_residenza,
                    /*IDENTIFICAZIONE_TIPO: this.tipo_identificazione, IDENTIFICAZIONE_NUMERO_DOCUMENTO: this.numero_documento, IDENTIFICAZIONE_AUTORITA: this.autorita_localita_rilascio, 
                    IDENTIFICAZIONE_DATA: this.data, IDENTIFICAZIONE_DATA_SCADENZA: this.data_scadenza, IDENTIFICAZIONE_TIPO_DOCUMENTO: this.tipo_documento, IDENTIFICAZIONE_DATA_RILASCIO: this.data_rilascio, 
                    MODALITA_ACQUISIZIONE_DATI: this.dati_acquisiti,*/
                    TITOLARE_EFFETTIVO: this.titolare_effettivo, PEP: this.pep, RAPPRESENTANTE_PRINCIPALE: this.rappresentante_principale, NON_IN_CARICA: this.non_in_carica
                });
                let datiJSON=JSON.stringify(dati[0]);
                console.log(`dati inviati`);
                console.log(datiJSON);
                let salvaValori = [];
                await AntiriciclaggioServices.updateSoggetto(datiJSON, this.idCliente, this.idSoggetto) 
                .then(response => { salvaValori= response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                    errore = error.response.status;
                    }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
                // let path = '/prestazioni?idCliente=' + this.idCliente;
                let path = 'uploadfile-soggetto?idCliente=' + this.idCliente + '&idSoggetto=' + this.idSoggetto; 
                this.$router.push({
                    path: path
                }) 
            } else {
                alert("Compilare tutti i dati!");
            }
        },

        main: async function() {
            this.idCliente = this.$route.query.idCliente;
            try {
                await this.getAllSoggetti();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                await Services.refreshTokenFunction();
                }
            }
        },
    },
    
    mounted() {
        this.main();
    } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }
</style>
